<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="table-core">
      <base-table-pagination
        ref="baseTablePagRef"
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-refresh @applyFilters="applyFiltersHandler" />
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
    <kendo-grid-component
      :spanish="spanish"
      :dataResult='kendo.dataResult'
      :kendo="kendo"
      :loading='isGeneralLoading'
      :selectedField="selectedField"
      @datastatechange='dataStateChange'
      @columnreorder='columnReorder'
      @rowclick='openPath'
      @columnssubmit='onColumnsSubmit'
      @sortchange='sortChange'
      @filterchange='filterChange'
      @selectionchange="onSelectionChange"
      @headerselectionchange="onHeaderSelectionChange">
    </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-table-select-actions-expand
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
        :baseDropDownVisible="isMoreActionsVisible && hasSelected"
      >
        <template slot="commons">
          <base-button :disabled="!hasSelected" size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" :ariaHidden="true"/>
            {{ $t('app.unselect') }}
          </base-button>
        </template>
        <template slot="more">
          <span v-for="action in getAccionesPosibles" :key="action.IdAccion">
            <base-button-item-list theme="dark" @click="executeAction(action)">
              <base-icon :name="selectIcon(action.IdAccion)" class="mr-2" :ariaHidden="true"/>
                {{ action.Descripcion }}
            </base-button-item-list>
          </span>
        </template>
      </base-table-select-actions-expand>
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <!-- <base-button-responsive mode="primary" :text="$t('procedings.new')" icon="plus" @click="goToNewAPIRequest" :loading="isGeneralLoading"/> -->
        </template>
      </base-footer>
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>
      <p-d-f-viewer-dialog
        :dialogOpen="showModalPDF"
        :idAdjunto="idDiligenciaSelected"
        @toggleDialog="toggleDialogPdf" 
        isDiligencia
        />
    </template>
  </list-layout>
</template>

<script>
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/ProcedingsFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import KendoGridComponent from '../../components/KendoGridComponent.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import { process } from '@progress/kendo-data-query'
import { i18n } from '@/i18n'
import PDFViewerDialog from '@/components/pdf/PDFViewerDialog.vue'

import { getProcedingsPag } from '@/services/procedings/getProcedingsPag'
import { downloadProcedingsExcel } from '@/services/procedings/downloadProcedingsExcel'

import { cambiarestadodiligencias } from '@/services/procedings/cambiarestadodiligencias'
import { descargardocumentodiligencia } from '@/services/procedings/descargardocumentodiligencia'

// import { cancelProcedings } from '@/services/configurations/procedings/cancelProcedings'
// import { retryProcedings } from '@/services/configurations/procedings/retryProcedings'

export default {
  name: 'vista-contestacion-diligencias',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    KendoGridComponent,
    CreateSearchDialog,
    PDFViewerDialog,
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 35,
      idVista: 90,
      // Links
      isLoadedData: false,

      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,

      // All
      showModalPDF: false,
      loadingExcel: false,
      spanish: true,
      showModal: false,
      header: {
        title: i18n.t('procedings.title'),
        icon: 'config',
        breadcrumb: null,
        url: null
      },
      vuexnamespace: 'procedings',
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      showModalDuplicate: false,
      data: null,
      selected: [],
      listaAcciones: [
        { IdAccion: 100, Descripcion: i18n.t('documentmaster.visualize') },
        { IdAccion: 300, Descripcion: i18n.t('documentmaster.download') },
        { IdAccion: 201, Descripcion: i18n.t('app.retry') },
        { IdAccion: 202, Descripcion: i18n.t('imports.cancel') },
      ],
    }
  },
  computed: {
    idDiligenciaSelected () {
      if (!this.selected || this.selected.length !== 1) return -1
      return this.selected[0].idDiligencia
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return this.$i18n.t('app.export_excel') + ' (Seleccionados)'
      return this.$i18n.t('app.export_excel')
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    setLabelTowShow: function () {
      return this.showAllRows ? 'Solo Seleccionadas' : 'Ver Todas'
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    isMoreActionsVisible: function () {
      return this.getAccionesPosibles !== undefined && this.getAccionesPosibles.length > 0
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    selectIcon: function (action) {
      return (action) =>
        action === 100 ? 'eye'
          : action === 300 ? 'download'
            : action === 201 ? 'retry'
              : 'trash'
    },
    getAccionesPosibles () {
      let listaAccionesFinal = this.listaAcciones.slice()
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 0) {
        // Si es más de 1 solo cancelar y reintentar
        if (this.selected.length > 1) {
          listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 300 && x.IdAccion !== 100)
        } 
        // Si hay alguno procesando o en error, no se puede descargar ni ver el resultado
        if (this.selected.filter(x => x.idEstado !== 1).length > 0) {
          listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 300 && x.IdAccion !== 100)
        }
        // Si no son todos en Error no se puede cancelar o reintentar
        if (this.selected.length !== this.selected.filter(x => x.idEstado === 2).length) {
          listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 201 && x.IdAccion !== 202)
        } 
      }
      return listaAccionesFinal
    },
    firstSelected () {
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 0) return this.selected[0].idDiligencia
      return 0
    }
  },
  watch: {
    $route (to, from) {
      if (this.$route.params.data) {
        this.filterByParamsData()
      }
      this.updateOnRouteChange(to, from)
      // this.routerChangeHandler()
    },
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
    data (val, oldVal) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group
      }
      this.kendo.dataResult = process(val, dataState)
      this.unselect()
    },
  },
  created: async function () {
    if (this.$route.params.data) {
      this.filterByParamsData()
    }
  },
  mounted: async function () {
    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
    this.data = await this.applyFilters()
  },
  methods: {
    handleOpenModalDialog (refName) {
      this.handleOpenModalDialogMixin(refName)
    },
    releaseFocusDialog () {
      this.releaseFocusDialogMixin()
    },
    filterByParamsData: function () {
      const data = this.$route.params.data
      const filters = {}
      if (data) {
        data.filters.forEach(filter => {
          if (filter.type === 'cliente') {
            const cliente = { label: 'Cliente', value: filter.data.label }
            filters.empresa = cliente
          } else if (filter.type === 'ticketid') {
            const ticket = { label: 'Ticket ID', value: filter.data }
            filters.ticketId = ticket
          } else if (filter.type === 'diligenciasError') {
            // Mantenemos filtro de cliente
            const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
            if (data.empresa) filters.empresa = { label: data.empresa.label, value: data.empresa.value } 

            const tipoDiligenciaEstado = { label: this.$i18n.t('procedings.Estado'), value: 2 }
            filters.tipoDiligenciaEstado = tipoDiligenciaEstado
          }
        })
        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filters)
      }
    },
    updateAllSelectedHeader: function () {
      if (!this.hasSelected) {
        this.kendo.columns[0].headerSelectionValue = false
      } else {
        this.kendo.columns[0].headerSelectionValue = this.areAllSelected
      }
    },
    openPath: function (event) {
      this.$store.commit('app/setheaderBreadCrumb', event.dataItem.NumDiligencia)
      this.$router.push({ name: 'procedings/details', params: { id: event.dataItem.idDiligencia, idNEO: -1 } })
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    createAppState: function (dataState) {
      this.kendo.take = dataState.take
      this.kendo.skip = dataState.skip
      if (dataState.group) {
        // eslint-disable-next-line no-return-assign
        // dataState.group.map(group => group.aggregates = this.aggregates)
      }
      this.kendo.group = dataState.group
      this.kendo.filter = dataState.filter
      this.kendo.sort = dataState.sort
    },
    dataStateChange: async function (event) {
      this.createAppState(event.data)
      this.data = await this.applyFilters()
    },
    columnReorder: function (options) {      
      this.sendUpdatedColumns(options.columns)      
      // Fix temporal para mostrar columnas después de reordenar
      this.kendo.columns.forEach((column, index) => {
        if (options.columns.filter(x => x.field === column.field).length === 0) {
          column.orderIndex = index + this.kendo.columns.length
          options.columns.push(column)
        }
      })
      this.kendo.columns = options.columns
      // Old sin fix
      // this.kendo.columns = options.columns
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        Distribuidor: data.distribuidor ? data.distribuidor.value : null,
        Empresa: data.empresa ? data.empresa.value : null,

        NumDiligencia: data.NumDiligencia ? data.NumDiligencia.value : null,
        idTipo: data.tipoDiligencia ? data.tipoDiligencia.value : null,
        idEstado: data.tipoDiligenciaEstado ? data.tipoDiligenciaEstado.value : null,
        NIFPagadora: data.NIFPagadora ? data.NIFPagadora.value : null,
        NIFDeudor: data.NIFDeudor ? data.NIFDeudor.value : null,
        CSV: data.CSV ? data.CSV.value : null,
        Error: data.Error ? data.Error.value : null,
        TicketID: data.ticketId ? data.ticketId.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
        const payload = { order: objOrder.order, grupos: objColumnas }
        if (this.hasSelected) {
          const selectedIDs = this.selected.map(x => x.idDiligencia)
          payload.listaIDs = selectedIDs
        }
        const response = await downloadProcedingsExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'contestacion-diligencias.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    onColumnsSubmit: function (columnsState) {
      this.sendUpdatedColumns(columnsState)
      this.kendo.columns = columnsState
    },
    sortChange: function (e) {
      let sort = e.sort
      if (Array.isArray(e)) {
        sort = e
      }
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: sort,
        group: this.kendo.group,
        filter: this.kendo.filter
      }
      this.dataStateChange({ data: dataState })
    },
    filterChange: function (filter) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group,
        filter: filter
      }

      this.dataStateChange({ data: dataState })
    },
    expandChange: function (event) {
      event.dataItem[event.target.$props.expandField] = !event.dataItem[event.target.$props.expandField]
    },
    updateOnRouteChange: async function (to, from) {
      await this.applyFilters()
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        Distribuidor: data.distribuidor ? data.distribuidor.value : null,
        Empresa: data.empresa ? data.empresa.value : null,

        NumDiligencia: data.NumDiligencia ? data.NumDiligencia.value : null,
        idTipo: data.tipoDiligencia ? data.tipoDiligencia.value : null,
        idEstado: data.tipoDiligenciaEstado ? data.tipoDiligenciaEstado.value : null,
        NIFPagadora: data.NIFPagadora ? data.NIFPagadora.value : null,
        NIFDeudor: data.NIFDeudor ? data.NIFDeudor.value : null,
        CSV: data.CSV ? data.CSV.value : null,
        Error: data.Error ? data.Error.value : null,
        TicketID: data.ticketId ? data.ticketId.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        this.data = await this.getItemsData(objOrder, params)
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback()
      }
      this.updateAllSelectedHeader()
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      this.data = res.respuesta
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      
      this.updatePersistedSortMixin()
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getProcedingsPag(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
      } else {
        setTimeout(() => {
          this.$nextTick(() => { 
            if (this.$refs.baseTablePagRef) this.$refs.baseTablePagRef.focus() 
          })
          this.doFeedback('Se han refrescado los datos del grid actual', 'info', 3000, true)
        }, 200)
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    tableSortByChangeHandler: function ({ prop, order }) {
      this.$store.commit(this.vuexnamespace + '/setSort', prop)
      this.$store.commit(this.vuexnamespace + '/setSortOrder', order)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.applyFilters(null)
    },
    unselect: function () {
      const checked = false
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    onHeaderSelectionChange: function (event) {
      const checked = event.event.target.checked
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    executeAction: async function (action) {
      this.selectedAction = action
      if (this.selectedAction.IdAccion === 100) { 
        this.toggleDialogPdf()
      } else if (this.selectedAction.IdAccion === 300) { 
        this.downloadAdjunto(this.idDiligenciaSelected)
      } else if (this.selectedAction.IdAccion === 201) { 
        this.actualizarEstadoHandler(0)
      } else if (this.selectedAction.IdAccion === 202) { 
        this.actualizarEstadoHandler(3)
      } else {
        console.error('Acción desconocida')
      }
    },
    toggleDialogPdf () {
      this.showModalPDF = !this.showModalPDF
    },
    downloadAdjunto: async function (idDiligencia) {
      this.$store.commit('setIsLoading', true)
      try {
        const params = {
          idDiligencia: idDiligencia
        }
        const response = await descargardocumentodiligencia(params)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          const fileName = 'respuesta-diligencia-' + idDiligencia + '.pdf'
          this.downloadBlob(response, fileName)
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    actualizarEstadoHandler: async function (idEstadoFinal = null) {
      try {
        this.$store.commit('setIsLoading', true)
        const selected = this.selected
        const payload = {
          idDiligencias: selected.map(x => x.idDiligencia),
          idEstado: idEstadoFinal,
        }
        const res = await cambiarestadodiligencias(payload)
        if (res.blnError) {
          this.doFeedback(res.msgError + ' [Código de error: ' + res.codError + ']')
        } else {
          this.doFeedback('Acción tramitada correctamente', 'success')
          this.data = await this.applyFilters()
          this.$store.dispatch('app/getAnnouncementsList')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    onSelectionChange: function (event) {
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField]
      this.selected = event.dataItems.filter(d => d.selected === true)
      this.updateAllSelectedHeader()
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>
